<template>
  <div class="education-column-notice-activity-list-component">
    <div class="education-column-notice-activity-item"
         v-for="item in list"
         :key="item.id"
         @click="handleClick"
    >
      <ym-tag class="education-column-notice-activity-tag"
              text="即将开始"
              type="primary-gradient"
      />
      <ym-img class="education-column-notice-activity-cover"
              :src="item.squareCover"
              :alt="item.title"
      />
      <div class="education-column-notice-activity-content">
        <div class="education-column-notice-activity-info">
          <h3 class="education-column-notice-activity-title ym-two-line-ellipsis">
            {{ item.title }}
          </h3>
          <div class="education-column-notice-activity-summary ym-line-ellipsis">
            {{ item.summary }}
          </div>
        </div>
        <div class="education-column-notice-activity-start-time">
          {{ item.startTime | formatTime('MM-dd HH:ii') }}开始
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import YmTag from '@/components/YmTag';
  import YmImg from '@/components/YmImg';

  export default {
    name: 'EducationColumnNoticeActivityList',
    components: {
      YmTag,
      YmImg,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      hint: String,
    },
    methods: {
      handleClick() {
        const { hint } = this;
        if (hint) {
          this.$dialog({
            title: '温馨提示',
            message: hint,
            confirmButtonText: '知道了',
          });
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .education-column-notice-activity {
    &-list-component {
      padding: 0 @size-base;
    }

    &-item {
      display: flex;
      padding: @size-base;
      margin-bottom: @size-base;
      overflow: hidden;
      position: relative;
      border-radius: @education-column-border-radius;
      background-color: @color-white;
    }

    &-tag {
      position: absolute;
      top: 0;
      left: 0;
      border-top-right-radius: 0;
    }

    &-cover {
      display: block;
      width: @education-column-notice-activity-cover-size;
      height: @education-column-notice-activity-cover-size;
      margin-right: @size-small;
      border-radius: @education-column-notice-activity-cover-border-radius;
    }

    &-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: hidden;
    }

    &-title {
      margin: 0 0 @size-extra-small;
      font-size: @font-size-large;
    }

    &-summary {
      font-size: @font-size-base;
      color: @color-text-lighter;
    }

    &-start-time {
      font-size: @font-size-base;
      color: @color-text-lighter;
    }
  }
</style>
